// Client type carried by the JWT `type` claim — PMC (property-management company) or OWNER (property owner).

export enum ClientType {
  PMC = 'PMC',
  OWNER = 'OWNER',
}

const CLIENT_TYPES: readonly unknown[] = Object.values(ClientType);

/** Narrow a raw, untrusted JWT claim value to a known client type, or `undefined` when it is neither. */
export function toClientType(value: unknown): ClientType | undefined {
  return CLIENT_TYPES.includes(value) ? (value as ClientType) : undefined;
}
